document.addEventListener('DOMContentLoaded', function () {
  function initScrollToBundle() {
    var bundle = document.getElementById('tt-bundle-pricing');
    if (!bundle) return;

    document.querySelectorAll('[data-tt-scroll-to-bundle]').forEach(function (link) {
      if (link.dataset.ttScrollBound === '1') return;
      link.dataset.ttScrollBound = '1';

      link.addEventListener('click', function (e) {
        e.preventDefault();
        bundle.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) {
          history.replaceState(null, '', '#tt-bundle-pricing');
        }
      });
    });
  }

  initScrollToBundle();
  document.addEventListener('shopify:section:load', initScrollToBundle);

  function forceJudgeMeGold() {
    const styleId = 'jdgm-force-gold-final';

    const existing = document.getElementById(styleId);
    if (existing) existing.remove();

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-rating,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-rating__score,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-rating__stars,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-star,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-text__text,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-verified-by__text {
  color: #f28c34 !important;
}

/* Verified badge base color */
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-verified-by svg {
  color: #f28c34 !important;
}
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-verified-by svg * {
  fill: #ffffff !important;
}
/* Verified badge: remove green background */
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-verified-by svg path,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-verified-by svg polyline {
  fill: none !important;
  stroke: #f28c34 !important;
}

/* Orange stars/icons */
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-rating svg path,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-rating svg polygon,
.jdgm-widget.jdgm-all-reviews-text.jdgm-all-reviews-text--style-branded .jdgm-all-reviews-rating svg * {
  fill: #f28c34 !important;
  color: #f28c34 !important;
}
`;
    document.head.appendChild(style);
  }

  forceJudgeMeGold();
  setTimeout(forceJudgeMeGold, 500);
  setTimeout(forceJudgeMeGold, 1500);
});